import { useIntl } from 'react-intl';
import { Button, Divider, Form } from 'antd';

import { Helmet } from 'react-helmet';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';

import CashMovementForm from '../../../components/Financial/CashMovement/CashMovementForm';
import { CashMovementFormValues } from '@/core/domain/financial/BoxMovement/BoxMovement.types';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useDisclosure } from '@/hooks';
import CashMovementReportModal from './CashMovementReportModal';
import BankingEntryRegisterModal from '@/components/Financial/BankingEntry/BankingEntryRegisterModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function CashMovementPage({ route }: PageProps) {
  const intl = useIntl();
  const [reportModal, setReportModal] = useDisclosure();
  const [registerBankingEntryOpened, registerBankingEntryAction] =
    useDisclosure();

  const [form] = Form.useForm<CashMovementFormValues>();

  const bankAccountIds = Form.useWatch('bankAccountIds', form);
  const companiesIds = Form.useWatch('companyIds', form);
  const finalDate = Form.useWatch('finalDate', form);
  const initialDate = Form.useWatch('startDate', form);

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <TabContentWrapper permissions={route.permissions} title={route.name}>
        <CashMovementForm form={form} />

        <Divider />

        <SpaceForButton>
          <Button
            type="primary"
            block
            onClick={registerBankingEntryAction.open}
            disabled={
              !hasPermissions([Authorities.FINANCIAL_BANKING_ENTRIES_ADD])
            }
          >
            Novo Lançamento
          </Button>

          <Button
            block
            onClick={setReportModal.open}
            type="primary"
            disabled={
              !!!initialDate ||
              !!!finalDate ||
              !hasPermissions([
                Authorities.BANKING_ENTRIES_CASH_MOVEMENT_REPORT,
              ])
            }
          >
            Relatório
          </Button>
        </SpaceForButton>
      </TabContentWrapper>

      <CashMovementReportModal
        open={reportModal}
        onCancel={setReportModal.close}
        bankAccountIds={bankAccountIds}
        companiesIds={companiesIds}
        finalDate={finalDate}
        initialDate={initialDate}
      />

      <BankingEntryRegisterModal
        createAgain
        open={registerBankingEntryOpened}
        onCancel={registerBankingEntryAction.close}
      />
    </>
  );
}

export default CashMovementPage;
